import { render, staticRenderFns } from "./CargoQuoteUpdateStatus.vue?vue&type=template&id=82b32584&"
import script from "./CargoQuoteUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./CargoQuoteUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuoteUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuoteUpdateStatus.vue"
export default component.exports